import React from 'react'

const TestPage: React.FC = () => {
  return (
    <div style={{ 
      padding: '20px', 
      backgroundColor: 'white', 
      color: 'black',
      minHeight: '100vh'
    }}>
      <h1>Test Page - Epic3 Debug</h1>
      <p>このページが表示されていれば、React とルーティングは正常に動作しています。</p>
      
      <div style={{ marginTop: '20px' }}>
        <h2>基本情報</h2>
        <ul>
          <li>現在時刻: {new Date().toLocaleString()}</li>
          <li>ページ: Test Page</li>
          <li>React: 動作中</li>
        </ul>
      </div>
      
      <div style={{ marginTop: '20px' }}>
        <h2>ナビゲーションテスト</h2>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <a href="/" style={{ padding: '10px', backgroundColor: '#007bff', color: 'white', textDecoration: 'none', borderRadius: '4px' }}>
            ホーム
          </a>
          <a href="/player" style={{ padding: '10px', backgroundColor: '#28a745', color: 'white', textDecoration: 'none', borderRadius: '4px' }}>
            プレイヤー
          </a>
          <a href="/admin" style={{ padding: '10px', backgroundColor: '#dc3545', color: 'white', textDecoration: 'none', borderRadius: '4px' }}>
            管理画面
          </a>
          <a href="/survey" style={{ padding: '10px', backgroundColor: '#ffc107', color: 'black', textDecoration: 'none', borderRadius: '4px' }}>
            アンケート
          </a>
        </div>
      </div>
      
      <div style={{ marginTop: '20px' }}>
        <h2>Console テスト</h2>
        <button 
          onClick={() => console.log('Test button clicked!')}
          style={{ padding: '10px', backgroundColor: '#17a2b8', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
        >
          Console ログテスト
        </button>
      </div>
      
      <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px' }}>
        <h3>問題が解決したら</h3>
        <p>このテストページが正常に表示されたら、元のページの問題を特定できます。</p>
        <p>F12 開発者ツールのConsoleタブでエラーがないか確認してください。</p>
      </div>
    </div>
  )
}

export default TestPage